import { EventEmitter, Component, Input, Output, ContentChildren, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { Subject, BehaviorSubject } from 'rxjs';
import { subDays, format } from 'date-fns';
import { tap, map } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormUtilitiesModule } from '@braune-digital/form-utilities';
import { DatepickerModule } from 'ngx-bootstrap/datepicker';
import { PaginationModule } from 'ngx-bootstrap/pagination';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@ngx-translate/core';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from '@angular/forms';
import * as ɵngcc4 from '@ng-select/ng-select';
import * as ɵngcc5 from '@braune-digital/form-utilities';
import * as ɵngcc6 from 'ngx-bootstrap/pagination';

function FilterComponent_ng_container_0_a_3_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 6);
    ɵngcc0.ɵɵlistener("click", function FilterComponent_ng_container_0_a_3_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(2); return ctx_r5.resetSearch(); });
    ɵngcc0.ɵɵelement(1, "i", 7);
    ɵngcc0.ɵɵelementEnd();
} }
const _c0 = function (a0) { return { "filterbar--resetable": a0 }; };
function FilterComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 3)(2, "input", 4);
    ɵngcc0.ɵɵlistener("ngModelChange", function FilterComponent_ng_container_0_Template_input_ngModelChange_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.model = $event; })("keyup", function FilterComponent_ng_container_0_Template_input_keyup_2_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.onKeyPress(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, FilterComponent_ng_container_0_a_3_Template, 2, 0, "a", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(4, _c0, ctx_r0.resetable && ctx_r0.model));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.model)("placeholder", ctx_r0.filterPlaceholder);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.resetable && ctx_r0.model);
} }
function FilterComponent_ng_select_1_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ng-select", 8);
    ɵngcc0.ɵɵlistener("ngModelChange", function FilterComponent_ng_select_1_Template_ng_select_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.model = $event; })("change", function FilterComponent_ng_select_1_Template_ng_select_change_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.onChange($event); })("remove", function FilterComponent_ng_select_1_Template_ng_select_remove_0_listener() { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r13 = ɵngcc0.ɵɵnextContext(); return ctx_r13.onRemove(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.model)("placeholder", ctx_r1.filterPlaceholder)("items", ctx_r1._options)("searchable", ctx_r1.selectSearchable)("disabled", ctx_r1.disabled);
} }
function FilterComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r15 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "bd-daterange", 9);
    ɵngcc0.ɵɵlistener("datesPicked", function FilterComponent_ng_container_2_Template_bd_daterange_datesPicked_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r14 = ɵngcc0.ɵɵnextContext(); return ctx_r14.onDatesPicked($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("placeholder", ctx_r2.filterPlaceholder)("triggers", ctx_r2.datepickerTrigger)("minDate", ctx_r2.minDate)("maxDate", ctx_r2.maxDate)("bsLang", ctx_r2.lang);
} }
function FilterComponent_ng_select_3_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ng-select", 10);
    ɵngcc0.ɵɵlistener("ngModelChange", function FilterComponent_ng_select_3_Template_ng_select_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r16 = ɵngcc0.ɵɵnextContext(); return ctx_r16.model = $event; })("change", function FilterComponent_ng_select_3_Template_ng_select_change_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r18 = ɵngcc0.ɵɵnextContext(); return ctx_r18.onChange($event); })("remove", function FilterComponent_ng_select_3_Template_ng_select_remove_0_listener() { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r19 = ɵngcc0.ɵɵnextContext(); return ctx_r19.onRemove(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngModel", ctx_r3.model)("placeholder", ctx_r3.filterPlaceholder)("items", ctx_r3._options);
} }
function ListContainerComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵprojection(1);
    ɵngcc0.ɵɵelementContainerEnd();
} }
function ListContainerComponent_ng_container_2_paginationFilter_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "paginationFilter", 3);
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("showOnLoading", true)("filterService", ctx_r5.filter);
} }
function ListContainerComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵprojection(1, 1);
    ɵngcc0.ɵɵtemplate(2, ListContainerComponent_ng_container_2_paginationFilter_2_Template, 1, 2, "paginationFilter", 2);
    ɵngcc0.ɵɵpipe(3, "async");
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    let tmp_0_0;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ((tmp_0_0 = ɵngcc0.ɵɵpipeBind1(3, 1, ctx_r1.filter.responseEvent)) == null ? null : tmp_0_0.length) && !ctx_r1.hidePagination);
} }
function ListContainerComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵprojection(1, 2);
    ɵngcc0.ɵɵelementContainerEnd();
} }
function ListContainerComponent_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵprojection(1, 3);
    ɵngcc0.ɵɵelementContainerEnd();
} }
function ListContainerComponent_ng_container_8_list_loading_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "list-loading");
} }
function ListContainerComponent_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", null, 4);
    ɵngcc0.ɵɵprojection(3, 4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, ListContainerComponent_ng_container_8_list_loading_4_Template, 1, 0, "list-loading", 1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r6 = ɵngcc0.ɵɵreference(2);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngIf", _r6.childNodes.length == 0);
} }
const _c1 = [[["", "filter", ""]], [["", "list", ""]], [["", "noResults", ""]], [["", "ghost", ""]], [["", "loading", ""]]];
const _c2 = function (a0) { return { "init-state": a0 }; };
const _c3 = ["[filter]", "[list]", "[noResults]", "[ghost]", "[loading]"];
function InfinityListComponent_ng_container_1_list_loading_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "list-loading");
} }
function InfinityListComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", null, 2);
    ɵngcc0.ɵɵprojection(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, InfinityListComponent_ng_container_1_list_loading_4_Template, 1, 0, "list-loading", 1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r4 = ɵngcc0.ɵɵreference(2);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngIf", _r4.childNodes.length == 0);
} }
function InfinityListComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵprojection(1, 1);
    ɵngcc0.ɵɵelementContainerEnd();
} }
function InfinityListComponent_ng_container_4_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵlistener("click", function InfinityListComponent_ng_container_4_div_2_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(2); return ctx_r7.loadNext(); });
    ɵngcc0.ɵɵprojection(1, 3);
    ɵngcc0.ɵɵelementEnd();
} }
function InfinityListComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵprojection(1, 2);
    ɵngcc0.ɵɵtemplate(2, InfinityListComponent_ng_container_4_div_2_Template, 2, 0, "div", 3);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.firstLoaded && ctx_r2.filter.range.pages > ctx_r2.filter.page);
} }
function InfinityListComponent_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵprojection(1, 4);
    ɵngcc0.ɵɵelementContainerEnd();
} }
const _c4 = [[["", "loading", ""]], [["", "filter", ""]], [["", "list", ""]], [["", "next", ""]], [["", "noResults", ""]]];
const _c5 = ["[loading]", "[filter]", "[list]", "[next]", "[noResults]"];
const _c6 = "[_nghost-%COMP%]{position:relative;display:block}[_nghost-%COMP%]     list-loading{position:absolute;width:100%;height:100%;display:block;left:0;top:0;background-color:hsla(0,0%,100%,.7);z-index:90}[_nghost-%COMP%]     list-loading .loader{line-height:6px;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}[_nghost-%COMP%]   .init-state[_ngcontent-%COMP%]     list-loading{height:200px;position:relative}";
function PaginationFilterComponent_div_0_pagination_2_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "pagination", 5);
    ɵngcc0.ɵɵlistener("ngModelChange", function PaginationFilterComponent_div_0_pagination_2_Template_pagination_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(2); return ctx_r2.pageChanged($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("totalItems", ctx_r1.filterService.range.total)("itemsPerPage", ctx_r1.filterService.resultsPerPage)("ngModel", ctx_r1.filterService.page)("maxSize", ctx_r1.filterService.limitDisplayPages)("previousText", ctx_r1.previousText)("nextText", ctx_r1.nextText)("firstText", ctx_r1.firstText)("lastText", ctx_r1.lastText);
} }
function PaginationFilterComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1)(1, "div", 2);
    ɵngcc0.ɵɵtemplate(2, PaginationFilterComponent_div_0_pagination_2_Template, 1, 8, "pagination", 3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 2)(4, "results-per-page", 4);
    ɵngcc0.ɵɵlistener("refreshedResultsPerPage", function PaginationFilterComponent_div_0_Template_results_per_page_refreshedResultsPerPage_4_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.filterService.refresh(); });
    ɵngcc0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.filterService.range.pages > 1);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("filterService", ctx_r0.filterService)("resultKeys", ctx_r0.filterService.resultKeys);
} }
function OrderingComponent_i_2_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "i", 3);
    ɵngcc0.ɵɵlistener("click", function OrderingComponent_i_2_Template_i_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.refreshOrdering(true); });
    ɵngcc0.ɵɵelementEnd();
} }
function OrderingComponent_i_3_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "i", 4);
    ɵngcc0.ɵɵlistener("click", function OrderingComponent_i_3_Template_i_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.refreshOrdering(true); });
    ɵngcc0.ɵɵelementEnd();
} }
const _c7 = ["order", ""];
const _c8 = function (a0) { return { "active": a0 }; };
const _c9 = ["*"];
class Filter {
    constructor(name) {
        var _a;
        this.active = true;
        this.name = null;
        this.refreshEvent = new Subject();
        this.id = Math.random().toString(36).substr(2, 9);
        this.name = (_a = (name)) !== null && _a !== void 0 ? _a : null;
    }
    toJson() {
        if (this.name) {
            return Object.assign(Object.assign({}, this.get()), { name: this.name });
        }
        else {
            return this.get();
        }
    }
}

class DateTimeRangeFilter extends Filter {
    constructor(property, min, max, unit, name) {
        super(name);
        this.type = 'date_time_range';
        this.min = subDays(new Date(), 7);
        this.max = new Date();
        this.property = property;
        this.min = min;
        this.max = max;
        this.unit = unit;
    }
    get() {
        if (this.active) {
            const obj = {
                filter: this.type,
                property: this.property,
                min: this.min,
                max: this.max
            };
            Object.keys(obj).forEach(key => obj[key] == null && delete obj[key]);
            return obj;
        }
        return null;
    }
}

class InstanceofFilter extends Filter {
    constructor(values, name) {
        super(name);
        this.type = 'instanceof';
        this.property = 'id';
        this.values = values;
    }
    get() {
        if (this.active) {
            return {
                filter: this.type,
                property: this.property,
                values: this.values
            };
        }
        return null;
    }
}

class EqualFilter extends Filter {
    constructor(property, values, name) {
        super(name);
        this.type = 'equal';
        this.property = property;
        this.values = values;
    }
    get() {
        if (this.active) {
            return {
                filter: this.type,
                property: this.property,
                values: this.values
            };
        }
        return null;
    }
}

class TextFilter extends Filter {
    constructor(properties, text, name) {
        super(name);
        this.type = 'text';
        this.properties = properties;
        this.text = text;
    }
    get() {
        if (this.active) {
            return {
                filter: this.type,
                properties: this.properties,
                text: this.text
            };
        }
        return null;
    }
}

/*
 * @author Felix Baltruschat <fb@braune-digital.com>
 * @copyright 08.05.18 17:25 Braune Digital GmbH
 */
class FilterComponent {
    constructor(translate) {
        this.translate = translate;
        this.model = null;
        this.isResetting = false;
        this._options = [];
        this.type = "text";
        this.name = Math.random().toString(36).substr(2, 9);
        this.resetable = true;
        this.disabled = false;
        this.selectSearchable = true;
        this.filterPlaceholder = "";
        this.onRefreshFilter = new EventEmitter();
        /* Inputs for DateRange and Datepicker */
        /* Initialize lower and upper Date for default selection from very first date until today */
        this.lowerDate = new Date(0);
        this.upperDate = new Date();
        /* Min- and Maximum Date for picking Range*/
        this.minDate = new Date();
        this.maxDate = new Date();
        /* Triggers for bsDatepicker */
        this.datepickerTrigger = "click";
    }
    set options(options) {
        this._options = options.map((_) => {
            return {
                value: _.value,
                label: this.translate.instant(_.label),
            };
        });
    }
    getFilter() {
        return this.filter;
    }
    ngOnInit() {
        if (this.filterPlaceholder) {
            this.translate.get(this.filterPlaceholder).subscribe((res) => {
                this.filterPlaceholder = res;
            });
        }
        // const filterStored = RestoreService.get(this.name);
        this.initFilters();
    }
    initFilters() {
        switch (this.type) {
            case "text":
                this.addTextType();
                break;
            case "select":
                this.addSelectType();
                break;
            case "select_like":
                this.addSelectLikeType();
                break;
            case "instanceof":
                this.addInstanceOfType();
                break;
            case "date_time_range":
                this.addDateTimeRangeType();
                break;
        }
    }
    addDateTimeRangeType() {
        this.filter = new DateTimeRangeFilter(this.params.prop, this.lowerDate, this.upperDate, this.model, this.name);
    }
    addInstanceOfType() {
        this.filter = new InstanceofFilter(this.model, this.name);
    }
    addSelectLikeType() {
        this.filter = new TextFilter(this.params.properties, this.model, this.name);
        this.filter.active = false;
    }
    addSelectType() {
        this.filter = new EqualFilter(this.params.prop, this.model, this.name);
        this.filter.active = false;
    }
    addTextType() {
        this.filter = new TextFilter(this.params.properties, this.model, this.name);
    }
    /* Get Dates and set them to current filter*/
    onDatesPicked(dates) {
        if (dates && dates.length === 2) {
            this.lowerDate = dates[0];
            this.upperDate = dates[1];
        }
        else {
            this.lowerDate = new Date(0);
            this.upperDate = new Date();
        }
        this.refreshFilter();
    }
    onChange(data) {
        if (data) {
            this.model = data.value;
        }
        else {
            this.model = null;
        }
        this.filter.active = this.model !== null;
        this.refreshFilter();
    }
    onKeyPress() {
        this.filter.active = true;
        if (this.timeoutId ||
            (this.filter instanceof TextFilter && this.filter.text === this.model)) {
            window.clearTimeout(this.timeoutId);
        }
        this.timeoutId = setTimeout((_) => {
            this.refreshFilter();
        }, 500);
    }
    onRemove() {
        this.model = null;
        this.filter.active = false;
        this.refreshFilter();
    }
    reset() {
        this.isResetting = true;
        this.model = null;
        this.filter.active = false;
        this.isResetting = false;
    }
    resetSearch() {
        if (this.model) {
            this.model = "";
            this.refreshFilter();
        }
    }
    refreshFilter(emitEvent = true) {
        if (this.isResetting) {
            return;
        }
        this.filter.name = this.filter.name;
        this.refreshTypes();
        if (emitEvent) {
            this.onRefreshFilter.emit(this.filter);
        }
    }
    refreshTypes() {
        switch (this.type) {
            case "text":
                this.refreshTextFilter();
                break;
            case "select":
                this.refreshSelectFilter();
                break;
            case "select_like":
                this.refreshSelectLikeFilter();
                break;
            case "instanceof":
                this.refreshInstanceOfFilter();
                break;
            case "date_time_range":
                this.refreshDateTimeRangeFilter();
                break;
        }
    }
    refreshDateTimeRangeFilter() {
        this.filter.min = this.lowerDate;
        this.filter.max = this.upperDate;
        this.filter.unit = this.model;
    }
    refreshInstanceOfFilter() {
        this.filter.values = this.model;
    }
    refreshSelectLikeFilter() {
        this.filter.text = this.model;
    }
    refreshTextFilter() {
        this.filter.text = this.model;
    }
    refreshSelectFilter() {
        this.filter.values = this.model;
    }
    set(value, active = true) {
        this.model = value;
        this.filter.active = active;
        this.refreshFilter(false);
    }
}
FilterComponent.ɵfac = function FilterComponent_Factory(t) { return new (t || FilterComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.TranslateService)); };
FilterComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: FilterComponent, selectors: [["filter-component"]], inputs: { model: "model", type: "type", name: "name", resetable: "resetable", disabled: "disabled", selectSearchable: "selectSearchable", filterPlaceholder: "filterPlaceholder", lowerDate: "lowerDate", upperDate: "upperDate", minDate: "minDate", maxDate: "maxDate", datepickerTrigger: "datepickerTrigger", options: "options", text: "text", selectClass: "selectClass", params: "params", lang: "lang" }, outputs: { onRefreshFilter: "onRefreshFilter" }, decls: 4, vars: 4, consts: [[4, "ngIf"], ["bdSelect", "", "bindValue", "value", "bindLabel", "label", 3, "ngModel", "placeholder", "items", "searchable", "disabled", "ngModelChange", "change", "remove", 4, "ngIf"], ["bdSelect", "", "bindValue", "value", "bindLabel", "label", 3, "ngModel", "placeholder", "items", "ngModelChange", "change", "remove", 4, "ngIf"], [3, "ngClass"], ["name", "search", 1, "form-control", "form-control--small", 3, "ngModel", "placeholder", "ngModelChange", "keyup"], ["class", "filterbar--resetbtn", 3, "click", 4, "ngIf"], [1, "filterbar--resetbtn", 3, "click"], [1, "bd-icon", "icon-cross"], ["bdSelect", "", "bindValue", "value", "bindLabel", "label", 3, "ngModel", "placeholder", "items", "searchable", "disabled", "ngModelChange", "change", "remove"], [3, "placeholder", "triggers", "minDate", "maxDate", "bsLang", "datesPicked"], ["bdSelect", "", "bindValue", "value", "bindLabel", "label", 3, "ngModel", "placeholder", "items", "ngModelChange", "change", "remove"]], template: function FilterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, FilterComponent_ng_container_0_Template, 4, 6, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(1, FilterComponent_ng_select_1_Template, 1, 5, "ng-select", 1);
        ɵngcc0.ɵɵtemplate(2, FilterComponent_ng_container_2_Template, 2, 5, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(3, FilterComponent_ng_select_3_Template, 1, 3, "ng-select", 2);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.type === "text");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.type === "select" || ctx.type === "select_like");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.type === "date_time_range");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.type === "instanceof");
    } }, directives: [ɵngcc2.NgIf, ɵngcc2.NgClass, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc4.NgSelectComponent, ɵngcc5.SelectDirective, ɵngcc5.DaterangeComponent], encapsulation: 2 });
FilterComponent.ctorParameters = () => [
    { type: TranslateService }
];
FilterComponent.propDecorators = {
    model: [{ type: Input }],
    type: [{ type: Input }],
    options: [{ type: Input }],
    name: [{ type: Input }],
    text: [{ type: Input }],
    resetable: [{ type: Input }],
    disabled: [{ type: Input }],
    selectClass: [{ type: Input }],
    selectSearchable: [{ type: Input }],
    params: [{ type: Input }],
    filterPlaceholder: [{ type: Input }],
    onRefreshFilter: [{ type: Output }],
    lowerDate: [{ type: Input }],
    upperDate: [{ type: Input }],
    minDate: [{ type: Input }],
    maxDate: [{ type: Input }],
    lang: [{ type: Input }],
    datepickerTrigger: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FilterComponent, [{
        type: Component,
        args: [{
                selector: "filter-component",
                template: "<ng-container *ngIf=\"type === 'text'\">\n    <div [ngClass]=\"{'filterbar--resetable': resetable && model}\">\n        <input name=\"search\"\n               [(ngModel)]=\"model\"\n               (keyup)=\"onKeyPress()\"\n               [placeholder]=\"filterPlaceholder\"\n               class=\"form-control form-control--small\" />\n        <a class=\"filterbar--resetbtn\" (click)=\"resetSearch()\" *ngIf=\"resetable && model\">\n            <i class=\"bd-icon icon-cross\"></i>\n        </a>\n    </div>\n</ng-container>\n\n<ng-select *ngIf=\"type === 'select' || type === 'select_like'\"\n           bdSelect\n           [(ngModel)]=\"model\"\n           [placeholder]=\"filterPlaceholder\"\n           (change)=\"onChange($event)\"\n           (remove)=\"onRemove()\"\n           [items]=\"_options\"\n           [searchable]=\"selectSearchable\"\n           [disabled]=\"disabled\"\n           bindValue=\"value\"\n           bindLabel=\"label\"\n></ng-select>\n\n<ng-container *ngIf=\"type === 'date_time_range'\">\n    <bd-daterange  [placeholder]=\"filterPlaceholder\"\n                   (datesPicked)=\"onDatesPicked($event)\"\n                   [triggers]=\"datepickerTrigger\"\n                   [minDate]=\"minDate\"\n                   [maxDate]=\"maxDate\"\n                   [bsLang]=\"lang\"\n    >\n    </bd-daterange>\n</ng-container>\n\n<ng-select *ngIf=\"type === 'instanceof'\"\n           bdSelect\n           [(ngModel)]=\"model\"\n           [placeholder]=\"filterPlaceholder\"\n           (change)=\"onChange($event)\"\n           (remove)=\"onRemove()\"\n           [items]=\"_options\"\n           bindValue=\"value\"\n           bindLabel=\"label\"\n></ng-select>\n"
            }]
    }], function () { return [{ type: ɵngcc1.TranslateService }]; }, { model: [{
            type: Input
        }], type: [{
            type: Input
        }], name: [{
            type: Input
        }], resetable: [{
            type: Input
        }], disabled: [{
            type: Input
        }], selectSearchable: [{
            type: Input
        }], filterPlaceholder: [{
            type: Input
        }], onRefreshFilter: [{
            type: Output
        }], lowerDate: [{
            type: Input
        }], upperDate: [{
            type: Input
        }], minDate: [{
            type: Input
        }], maxDate: [{
            type: Input
        }], datepickerTrigger: [{
            type: Input
        }], options: [{
            type: Input
        }], text: [{
            type: Input
        }], selectClass: [{
            type: Input
        }], params: [{
            type: Input
        }], lang: [{
            type: Input
        }] }); })();

class ListContainerComponent {
    constructor() {
        this.hidePagination = false;
        this.firstLoaded = false;
    }
    ngOnInit() {
        this.isLoadingEventSubscription = this.filter.isLoadingEvent.subscribe((_) => {
            if (!_) {
                this.firstLoaded = true;
            }
        });
    }
    ngAfterViewInit() {
        this.filterComponents.forEach((filter) => {
            this.filter.add(filter);
        });
        this.filter.isReady.next(true);
    }
    resetFilter(withRefresh = true) {
        this.filterComponents.forEach((filterComponent) => filterComponent.reset());
        if (withRefresh) {
            this.filter.refresh();
        }
    }
    ngOnDestroy() {
        if (this.isLoadingEventSubscription) {
            this.isLoadingEventSubscription.unsubscribe();
        }
        this.firstLoaded = false;
    }
}
ListContainerComponent.ɵfac = function ListContainerComponent_Factory(t) { return new (t || ListContainerComponent)(); };
ListContainerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ListContainerComponent, selectors: [["list-container"]], contentQueries: function ListContainerComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, FilterComponent, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.filterComponents = _t);
    } }, inputs: { hidePagination: "hidePagination", firstLoaded: "firstLoaded", filter: "filter" }, ngContentSelectors: _c3, decls: 10, vars: 16, consts: [[3, "ngClass"], [4, "ngIf"], [3, "showOnLoading", "filterService", 4, "ngIf"], [3, "showOnLoading", "filterService"], ["ref", ""]], template: function ListContainerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c1);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, ListContainerComponent_ng_container_1_Template, 2, 0, "ng-container", 1);
        ɵngcc0.ɵɵtemplate(2, ListContainerComponent_ng_container_2_Template, 4, 3, "ng-container", 1);
        ɵngcc0.ɵɵpipe(3, "async");
        ɵngcc0.ɵɵtemplate(4, ListContainerComponent_ng_container_4_Template, 2, 0, "ng-container", 1);
        ɵngcc0.ɵɵpipe(5, "async");
        ɵngcc0.ɵɵtemplate(6, ListContainerComponent_ng_container_6_Template, 2, 0, "ng-container", 1);
        ɵngcc0.ɵɵpipe(7, "async");
        ɵngcc0.ɵɵtemplate(8, ListContainerComponent_ng_container_8_Template, 5, 1, "ng-container", 1);
        ɵngcc0.ɵɵpipe(9, "async");
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        let tmp_2_0;
        let tmp_3_0;
        let tmp_4_0;
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(14, _c2, !ctx.firstLoaded));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.firstLoaded);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ((tmp_2_0 = ɵngcc0.ɵɵpipeBind1(3, 6, ctx.filter.responseEvent)) == null ? null : tmp_2_0.length) && ctx.firstLoaded);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !((tmp_3_0 = ɵngcc0.ɵɵpipeBind1(5, 8, ctx.filter.responseEvent)) == null ? null : tmp_3_0.length) && ctx.firstLoaded);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !((tmp_4_0 = ɵngcc0.ɵɵpipeBind1(7, 10, ctx.filter.responseEvent)) == null ? null : tmp_4_0.length) && ctx.firstLoaded);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(9, 12, ctx.filter.isLoadingEvent) === true);
    } }, directives: function () { return [ɵngcc2.NgClass, ɵngcc2.NgIf, PaginationFilterComponent, ListLoadingComponent]; }, pipes: function () { return [ɵngcc2.AsyncPipe]; }, styles: [_c6] });
ListContainerComponent.propDecorators = {
    filter: [{ type: Input }],
    hidePagination: [{ type: Input }],
    firstLoaded: [{ type: Input }],
    filterComponents: [{ type: ContentChildren, args: [FilterComponent, { descendants: true },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ListContainerComponent, [{
        type: Component,
        args: [{
                selector: "list-container",
                template: "<div [ngClass]=\"{ 'init-state': !firstLoaded }\">\n  <ng-container *ngIf=\"firstLoaded\">\n    <ng-content select=\"[filter]\"></ng-content>\n  </ng-container>\n  <ng-container *ngIf=\"(filter.responseEvent | async)?.length && firstLoaded\">\n    <ng-content select=\"[list]\"></ng-content>\n    <paginationFilter\n      *ngIf=\"(filter.responseEvent | async)?.length && !hidePagination\"\n      [showOnLoading]=\"true\"\n      [filterService]=\"filter\"\n    ></paginationFilter>\n  </ng-container>\n  <ng-container *ngIf=\"!(filter.responseEvent | async)?.length && firstLoaded\">\n    <ng-content select=\"[noResults]\"></ng-content>\n  </ng-container>\n  <ng-container *ngIf=\"!(filter.responseEvent | async)?.length && firstLoaded\">\n    <ng-content select=\"[ghost]\"></ng-content>\n  </ng-container>\n  <ng-container *ngIf=\"(filter.isLoadingEvent | async) === true\">\n    <div #ref><ng-content select=\"[loading]\"></ng-content></div>\n    <list-loading *ngIf=\"ref.childNodes.length == 0\"></list-loading>\n  </ng-container>\n</div>\n",
                styles: [":host{position:relative;display:block}:host ::ng-deep list-loading{position:absolute;width:100%;height:100%;display:block;left:0;top:0;background-color:hsla(0,0%,100%,.7);z-index:90}:host ::ng-deep list-loading .loader{line-height:6px;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}:host .init-state ::ng-deep list-loading{height:200px;position:relative}"]
            }]
    }], function () { return []; }, { hidePagination: [{
            type: Input
        }], firstLoaded: [{
            type: Input
        }], filter: [{
            type: Input
        }], filterComponents: [{
            type: ContentChildren,
            args: [FilterComponent, { descendants: true }]
        }] }); })();

class InfinityListComponent {
    constructor() {
        this.firstLoaded = false;
    }
    ngOnInit() {
        this.isLoadingEventSubscription = this.filter.isLoadingEvent.subscribe(_ => {
            if (!_) {
                this.firstLoaded = true;
            }
        });
    }
    ngAfterViewInit() {
        this.filterComponents.forEach(filter => {
            this.filter.add(filter);
        });
        this.filter.isReady.next(true);
    }
    ngAfterContentInit() {
    }
    resetFilter(withRefresh = true) {
        this.filterComponents.forEach(filterComponent => filterComponent.reset());
        if (withRefresh) {
            this.filter.refresh();
        }
    }
    ngOnDestroy() {
        this.isLoadingEventSubscription.unsubscribe();
        this.firstLoaded = false;
    }
    loadNext() {
        this.filter.page++;
        this.filter.refresh();
    }
}
InfinityListComponent.ɵfac = function InfinityListComponent_Factory(t) { return new (t || InfinityListComponent)(); };
InfinityListComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: InfinityListComponent, selectors: [["infinity-list"]], contentQueries: function InfinityListComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, FilterComponent, 4);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.filterComponents = _t);
    } }, inputs: { filter: "filter" }, ngContentSelectors: _c5, decls: 8, vars: 13, consts: [[3, "ngClass"], [4, "ngIf"], ["ref", ""], [3, "click", 4, "ngIf"], [3, "click"]], template: function InfinityListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c4);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, InfinityListComponent_ng_container_1_Template, 5, 1, "ng-container", 1);
        ɵngcc0.ɵɵpipe(2, "async");
        ɵngcc0.ɵɵtemplate(3, InfinityListComponent_ng_container_3_Template, 2, 0, "ng-container", 1);
        ɵngcc0.ɵɵtemplate(4, InfinityListComponent_ng_container_4_Template, 3, 1, "ng-container", 1);
        ɵngcc0.ɵɵpipe(5, "async");
        ɵngcc0.ɵɵtemplate(6, InfinityListComponent_ng_container_6_Template, 2, 0, "ng-container", 1);
        ɵngcc0.ɵɵpipe(7, "async");
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        let tmp_3_0;
        let tmp_4_0;
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(11, _c2, !ctx.firstLoaded));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(2, 5, ctx.filter.isLoadingEvent) === true);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.firstLoaded);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ((tmp_3_0 = ɵngcc0.ɵɵpipeBind1(5, 7, ctx.filter.responseEvent)) == null ? null : tmp_3_0.length) && ctx.firstLoaded);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !((tmp_4_0 = ɵngcc0.ɵɵpipeBind1(7, 9, ctx.filter.responseEvent)) == null ? null : tmp_4_0.length) && ctx.firstLoaded);
    } }, directives: function () { return [ɵngcc2.NgClass, ɵngcc2.NgIf, ListLoadingComponent]; }, pipes: function () { return [ɵngcc2.AsyncPipe]; }, styles: [_c6] });
InfinityListComponent.propDecorators = {
    filter: [{ type: Input, args: ['filter',] }],
    filterComponents: [{ type: ContentChildren, args: [FilterComponent,] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(InfinityListComponent, [{
        type: Component,
        args: [{
                selector: 'infinity-list',
                template: "<div [ngClass]=\"{'init-state': !firstLoaded}\">\n    <ng-container *ngIf=\"(filter.isLoadingEvent | async) === true\">\n        <div #ref><ng-content select=\"[loading]\"></ng-content></div>\n        <list-loading *ngIf=\"ref.childNodes.length == 0\"></list-loading>\n    </ng-container>\n    <ng-container *ngIf=\"firstLoaded\">\n        <ng-content select=\"[filter]\"></ng-content>\n    </ng-container>\n    <ng-container *ngIf=\"(filter.responseEvent | async)?.length && firstLoaded\">\n        <ng-content select=\"[list]\"></ng-content>\n        <div (click)=\"loadNext()\" *ngIf=\"firstLoaded && filter.range.pages > filter.page\">\n            <ng-content select=\"[next]\"></ng-content>\n        </div>\n    </ng-container>\n    <ng-container *ngIf=\"!(filter.responseEvent | async)?.length && firstLoaded\">\n        <ng-content select=\"[noResults]\"></ng-content>\n    </ng-container>\n</div>",
                styles: [":host{position:relative;display:block}:host ::ng-deep list-loading{position:absolute;width:100%;height:100%;display:block;left:0;top:0;background-color:hsla(0,0%,100%,.7);z-index:90}:host ::ng-deep list-loading .loader{line-height:6px;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}:host .init-state ::ng-deep list-loading{height:200px;position:relative}"]
            }]
    }], function () { return []; }, { filter: [{
            type: Input,
            args: ['filter']
        }], filterComponents: [{
            type: ContentChildren,
            args: [FilterComponent]
        }] }); })();

class ListLoadingComponent {
}
ListLoadingComponent.ɵfac = function ListLoadingComponent_Factory(t) { return new (t || ListLoadingComponent)(); };
ListLoadingComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ListLoadingComponent, selectors: [["list-loading"]], decls: 4, vars: 0, consts: [[1, "loader"]], template: function ListLoadingComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "span", 0);
        ɵngcc0.ɵɵelement(1, "span")(2, "span")(3, "span");
        ɵngcc0.ɵɵelementEnd();
    } }, encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ListLoadingComponent, [{
        type: Component,
        args: [{
                selector: 'list-loading',
                template: "<span class=\"loader\">\n    <span></span>\n    <span></span>\n    <span></span>\n</span>"
            }]
    }], null, null); })();

class AndFilter extends Filter {
    constructor(filters, name) {
        super(name);
        this.type = 'and';
        this.filters = filters;
    }
    get() {
        if (!this.active) {
            return null;
        }
        const filterArray = [];
        this.filters.forEach(filter => {
            const f = filter.get();
            if (f) {
                filterArray.push(f);
            }
        });
        return {
            filter: this.type,
            filters: filterArray
        };
    }
}

class ParamFilter {
    constructor(_requestUrl, api, params = {}, withScope = true, headers = {} // important, do not delete!: init restore Service for static usage
    ) {
        this._requestUrl = _requestUrl;
        this.api = api;
        this.params = params;
        this.withScope = withScope;
        this.headers = headers;
        this.resultKeys = ParamFilter.resultKeys;
        this.filters = [];
        this.orderings = [];
        this.page = 1;
        this.limitDisplayPages = 5;
        this.range = {
            total: 0,
            pages: 0,
        };
        this.responseEvent = new BehaviorSubject([]);
        this.isLoadingEvent = new BehaviorSubject(true);
        this.isReady = new BehaviorSubject(false);
        this.resultsPerPage = 10;
        this.grouped = false;
    }
    refresh() {
        this.isLoadingEvent.next(true);
        this.refreshPromise().subscribe((response) => {
            this.responseEvent.next(response);
            this.isLoadingEvent.next(false);
        });
    }
    refreshPromise() {
        return this.api
            .get(this.requestUrl, {
            params: this.build(),
            observe: "response",
            headers: this.headers,
        })
            .pipe(tap((response) => this.preparePagination(response)), map((response) => response.body));
    }
    preparePagination(response) {
        if (response.headers.has("Content-Range")) {
            const hdr = response.headers.get("Content-Range");
            const m = hdr && hdr.match(/^(?:items )?(\d+)-(\d+)\/(\d+|\*)$/);
            if (m) {
                this.range = {
                    from: +m[1],
                    to: +m[2],
                    total: m[3] === "*" ? Infinity : +m[3],
                    pages: 0,
                };
            }
            else if (hdr === "*/0") {
                this.range = { total: 0, pages: 0 };
            }
            else {
                this.range = { total: 0, pages: 0 };
            }
            this.range["pages"] = Math.ceil((this.range ? this.range.total : response.json().length) /
                this.resultsPerPage);
            if (this.page <= 0) {
                this.page = this.range["pages"];
            }
        }
    }
    add(filter) {
        if (!filter) {
            return;
        }
        let f;
        if (filter instanceof Filter) {
            f = filter;
        }
        else if (filter instanceof FilterComponent) {
            f = filter.filter;
        }
        if (this.filters.indexOf(f) < 0) {
            this.filters.push(f);
        }
        else {
            this.filters[this.filters.findIndex((item) => item.id === f.id)] = f;
        }
    }
    addOrdering(ordering) {
        if (this.orderings.indexOf(ordering) < 0) {
            this.orderings.push(ordering);
        }
    }
    setOrderings(orderings) {
        this.orderings = orderings;
    }
    build() {
        const filterObjects = [];
        const searchParams = this.params;
        if (this.filters) {
            if (this.filters.length === 1) {
                const filter = this.filters[0].get();
                if (filter) {
                    filterObjects.push(filter);
                }
            }
            else {
                const andFilter = new AndFilter(this.filters);
                filterObjects.push(andFilter.toJson());
            }
        }
        const orderings = {};
        if (this.orderings) {
            this.orderings.forEach((ordering) => {
                if (ordering.active) {
                    orderings[ordering.property] = ordering.ordering;
                }
            });
        }
        const filterObjectsString = JSON.stringify(filterObjects);
        if (this.filtersFromLastRequest &&
            this.filtersFromLastRequest !== filterObjectsString) {
            this.page = 1;
        }
        this.filtersFromLastRequest = JSON.stringify(filterObjects);
        searchParams["filter"] = filterObjectsString;
        searchParams["order"] = JSON.stringify(orderings);
        searchParams["page"] = this.page.toString();
        searchParams["resultsPerPage"] = this.resultsPerPage.toString();
        if (this.grouped) {
            searchParams["grouped"] = this.grouped.toString();
        }
        return searchParams;
    }
    setResultsPerPage(results) {
        this.page = 1;
        this.resultsPerPage = results;
    }
    getResultsPerPage() {
        return this.resultsPerPage;
    }
    getOrdering(property) {
        return this.orderings.find((order) => order.property === property);
    }
    resetOrderings(refresh = false) {
        this.orderings.forEach((order) => (order.active = false));
        if (refresh) {
            this.refresh();
        }
    }
    removeOrdering(ordering) {
        this.orderings = this.orderings.filter((obj) => obj !== ordering);
        this.refresh();
    }
    getFilter() {
        return this.filters;
    }
    removeFilter(name) {
        this.filters = this.filters.filter((filter) => filter.name !== name);
    }
    setParams(queryParams) {
        this.params = queryParams;
        this.refresh();
    }
    removeParams() {
        this.params = {};
        this.refresh();
    }
    get requestUrl() {
        return this._requestUrl;
    }
    set requestUrl(value) {
        this._requestUrl = value;
    }
}
ParamFilter.resultKeys = [10, 25, 50];

class Ordering {
    constructor(property, ordering, active = false, name) {
        this.type = 'ordering';
        this.property = property;
        this.ordering = ordering;
        this.active = active;
        this.name = name;
    }
}

class InFilter extends Filter {
    constructor(property, values, name) {
        super(name);
        this.type = 'in';
        this.property = property;
        this.values = values;
    }
    get() {
        if (this.active) {
            return {
                filter: this.type,
                property: this.property,
                values: this.values
            };
        }
        return null;
    }
}

class IsNullFilter extends Filter {
    constructor(property, name) {
        super(name);
        this.type = 'is_null';
        this.property = property;
    }
    get() {
        if (this.active) {
            return {
                filter: this.type,
                property: this.property
            };
        }
        return null;
    }
}

class IsNotNullFilter extends Filter {
    constructor(property, name) {
        super(name);
        this.type = 'is_not_null';
        this.property = property;
    }
    get() {
        if (this.active) {
            return {
                filter: this.type,
                property: this.property
            };
        }
        return null;
    }
}

class DateTimeRangeFixedIntervalFilter extends DateTimeRangeFilter {
    get() {
        if (this.active) {
            return {
                filter: this.type,
                property: this.property,
                min: format(this.min, 'YYYY-MM-DDTHH:mm:ss.SSSZZ'),
                max: format(this.max, 'YYYY-MM-DDTHH:mm:ss.SSSZZ')
            };
        }
        return null;
    }
}

class CollectionCountFilter extends Filter {
    constructor(property, min = null, max = null, unit, name) {
        super(name);
        this.type = 'collection-count';
        this.min = null;
        this.max = null;
        this.property = property;
        this.min = min;
        this.max = max;
        this.unit = unit;
    }
    get() {
        if (this.active) {
            const obj = {
                filter: this.type,
                property: this.property,
                min: this.min,
                max: this.max
            };
            Object.keys(obj).forEach(key => obj[key] == null && delete obj[key]);
            return obj;
        }
        return null;
    }
}

class ResultsPerPageComponent {
    constructor(fb) {
        this.fb = fb;
        this.refreshedResultsPerPage = new EventEmitter();
    }
    ngOnInit() {
        this.form = this.fb.group({ pagination: this.filterService.getResultsPerPage() });
    }
    refreshResultsPerPage() {
        this.filterService.setResultsPerPage(this.form.value.pagination);
        this.refreshedResultsPerPage.emit(true);
    }
}
ResultsPerPageComponent.ɵfac = function ResultsPerPageComponent_Factory(t) { return new (t || ResultsPerPageComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.FormBuilder)); };
ResultsPerPageComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ResultsPerPageComponent, selectors: [["results-per-page"]], inputs: { filterService: "filterService", resultKeys: "resultKeys" }, outputs: { refreshedResultsPerPage: "refreshedResultsPerPage" }, decls: 2, vars: 7, consts: [["bdSelect", "", 3, "placeholder", "formControl", "items", "clearable", "searchable", "change"]], template: function ResultsPerPageComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "ng-select", 0);
        ɵngcc0.ɵɵlistener("change", function ResultsPerPageComponent_Template_ng_select_change_0_listener() { return ctx.refreshResultsPerPage(); });
        ɵngcc0.ɵɵpipe(1, "translate");
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵpropertyInterpolate("placeholder", ɵngcc0.ɵɵpipeBind1(1, 5, "forms.fields.results_per_page"));
        ɵngcc0.ɵɵproperty("formControl", ctx.form.get("pagination"))("items", ctx.resultKeys)("clearable", false)("searchable", false);
    } }, directives: [ɵngcc4.NgSelectComponent, ɵngcc5.SelectDirective, ɵngcc3.NgControlStatus, ɵngcc3.FormControlDirective], pipes: [ɵngcc1.TranslatePipe], styles: ["[_nghost-%COMP%]   .form-group[_ngcontent-%COMP%]{margin-bottom:0}[_nghost-%COMP%]     ng-select.ng-select.ng-multiple .ng-control, [_nghost-%COMP%]     ng-select.ng-select.ng-single .ng-control{height:30px;margin-top:0}"] });
ResultsPerPageComponent.ctorParameters = () => [
    { type: FormBuilder }
];
ResultsPerPageComponent.propDecorators = {
    filterService: [{ type: Input }],
    resultKeys: [{ type: Input }],
    refreshedResultsPerPage: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ResultsPerPageComponent, [{
        type: Component,
        args: [{
                selector: 'results-per-page',
                template: "<ng-select\n   bdSelect\n   placeholder=\"{{ 'forms.fields.results_per_page' | translate }}\"\n   (change)=\"refreshResultsPerPage()\"\n   [formControl]=\"form.get('pagination')\"\n   [items]=\"resultKeys\"\n   [clearable]=\"false\"\n   [searchable]=\"false\"\n></ng-select>\n",
                styles: [":host .form-group{margin-bottom:0}:host ::ng-deep ng-select.ng-select.ng-multiple .ng-control,:host ::ng-deep ng-select.ng-select.ng-single .ng-control{height:30px;margin-top:0}"]
            }]
    }], function () { return [{ type: ɵngcc3.FormBuilder }]; }, { refreshedResultsPerPage: [{
            type: Output
        }], filterService: [{
            type: Input
        }], resultKeys: [{
            type: Input
        }] }); })();

class PaginationFilterComponent {
    constructor(translate) {
        this.translate = translate;
        this.showOnLoading = false;
        this.isLoading = true;
        this.previousText = 'pagination.previousText';
        this.nextText = 'pagination.nextText';
        this.firstText = 'pagination.firstText';
        this.lastText = 'pagination.lastText';
        this.translate.get([this.previousText, this.nextText, this.firstText, this.lastText]).subscribe((res) => {
            this.previousText = res['pagination.previousText'];
            this.nextText = res['pagination.nextText'];
            this.firstText = res['pagination.firstText'];
            this.lastText = res['pagination.lastText'];
        });
    }
    ngOnInit() {
        this.filterService.isLoadingEvent.subscribe((isLoading) => {
            this.isLoading = isLoading;
        });
    }
    pageChanged(page) {
        if (this.filterService.page !== page) {
            this.filterService.page = page;
            this.filterService.refresh();
        }
    }
}
PaginationFilterComponent.ɵfac = function PaginationFilterComponent_Factory(t) { return new (t || PaginationFilterComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.TranslateService)); };
PaginationFilterComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: PaginationFilterComponent, selectors: [["paginationFilter"]], inputs: { showOnLoading: "showOnLoading", filterService: "filterService" }, decls: 1, vars: 1, consts: [["class", "row pagination-bar", 4, "ngIf"], [1, "row", "pagination-bar"], [1, "col-md-6", "col-sm-12"], [3, "totalItems", "itemsPerPage", "ngModel", "maxSize", "previousText", "nextText", "firstText", "lastText", "ngModelChange", 4, "ngIf"], [3, "filterService", "resultKeys", "refreshedResultsPerPage"], [3, "totalItems", "itemsPerPage", "ngModel", "maxSize", "previousText", "nextText", "firstText", "lastText", "ngModelChange"]], template: function PaginationFilterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, PaginationFilterComponent_div_0_Template, 5, 3, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.showOnLoading || !ctx.isLoading);
    } }, directives: [ɵngcc2.NgIf, ɵngcc6.PaginationComponent, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ResultsPerPageComponent], styles: ["[_nghost-%COMP%]     results-per-page{float:right}"] });
PaginationFilterComponent.ctorParameters = () => [
    { type: TranslateService }
];
PaginationFilterComponent.propDecorators = {
    filterService: [{ type: Input }],
    showOnLoading: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PaginationFilterComponent, [{
        type: Component,
        args: [{
                selector: 'paginationFilter',
                template: "<div class=\"row pagination-bar\" *ngIf=\"(showOnLoading || !isLoading)\">\n    <div class=\"col-md-6 col-sm-12\">\n        <pagination [totalItems]=\"filterService.range.total\"\n                    [itemsPerPage]=\"filterService.resultsPerPage\"\n                    [ngModel]=\"filterService.page\"\n                    (ngModelChange)=\"pageChanged($event)\"\n                    [maxSize]=\"filterService.limitDisplayPages\"\n                    [previousText]=\"previousText\"\n                    [nextText]=\"nextText\"\n                    [firstText]=\"firstText\"\n                    [lastText]=\"lastText\"\n                    *ngIf=\"filterService.range.pages > 1\"\n        ></pagination>\n    </div>\n    <div class=\"col-md-6 col-sm-12\">\n        <results-per-page\n                [filterService]=\"filterService\"\n                [resultKeys]=\"filterService.resultKeys\"\n                (refreshedResultsPerPage)=\"filterService.refresh()\">\n        </results-per-page>\n    </div>\n</div>\n\n",
                styles: [":host ::ng-deep results-per-page{float:right}"]
            }]
    }], function () { return [{ type: ɵngcc1.TranslateService }]; }, { showOnLoading: [{
            type: Input
        }], filterService: [{
            type: Input
        }] }); })();

class OrderingComponent {
    constructor(fb, _translateService) {
        this.fb = fb;
        this._translateService = _translateService;
        this.reorder = new EventEmitter();
        this.orderings = [];
    }
    ngOnInit() {
        this.form = this.fb.group({ ordering: '' });
        this.orderKeys.forEach(orderKey => {
            this.orderings.push(new Ordering(orderKey.key, 'asc'));
        });
    }
    ngAfterViewInit() {
        this.filterService.setOrderings(this.orderings);
    }
    refreshOrdering(toggleAscDesc = false) {
        this.orderings = this.orderings.map(ordering => {
            ordering.active = ordering.property === this.form.value.ordering;
            if (toggleAscDesc) {
                if (ordering.ordering === 'asc') {
                    ordering.ordering = 'desc';
                }
                else {
                    ordering.ordering = 'asc';
                }
            }
            return ordering;
        });
        this.reorder.emit(true);
    }
    getActiveSort() {
        let activeOrdering;
        activeOrdering = this.orderings.find(ordering => (ordering.active));
        if (activeOrdering) {
            return activeOrdering.ordering;
        }
        else {
            return null;
        }
    }
}
OrderingComponent.ɵfac = function OrderingComponent_Factory(t) { return new (t || OrderingComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.FormBuilder), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.TranslateService)); };
OrderingComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OrderingComponent, selectors: [["ordering"]], inputs: { filterService: "filterService", orderKeys: "orderKeys" }, outputs: { reorder: "reorder" }, decls: 4, vars: 7, consts: [["bdSelect", "", "bindValue", "key", "bindLabel", "label", 3, "placeholder", "formControl", "items", "change"], ["class", "bd-icon bd-icon--big icon-arrow-down", 3, "click", 4, "ngIf"], ["class", "bd-icon bd-icon--big icon-arrow-up", 3, "click", 4, "ngIf"], [1, "bd-icon", "bd-icon--big", "icon-arrow-down", 3, "click"], [1, "bd-icon", "bd-icon--big", "icon-arrow-up", 3, "click"]], template: function OrderingComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "ng-select", 0);
        ɵngcc0.ɵɵlistener("change", function OrderingComponent_Template_ng_select_change_0_listener($event) { return ctx.refreshOrdering($event); });
        ɵngcc0.ɵɵpipe(1, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(2, OrderingComponent_i_2_Template, 1, 0, "i", 1);
        ɵngcc0.ɵɵtemplate(3, OrderingComponent_i_3_Template, 1, 0, "i", 2);
    } if (rf & 2) {
        ɵngcc0.ɵɵpropertyInterpolate("placeholder", ɵngcc0.ɵɵpipeBind1(1, 5, "forms.fields.order"));
        ɵngcc0.ɵɵproperty("formControl", ctx.form.get("ordering"))("items", ctx.orderKeys);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.getActiveSort() === "desc");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.getActiveSort() !== "desc");
    } }, directives: [ɵngcc4.NgSelectComponent, ɵngcc5.SelectDirective, ɵngcc3.NgControlStatus, ɵngcc3.FormControlDirective, ɵngcc2.NgIf], pipes: [ɵngcc1.TranslatePipe], encapsulation: 2 });
OrderingComponent.ctorParameters = () => [
    { type: FormBuilder },
    { type: TranslateService }
];
OrderingComponent.propDecorators = {
    filterService: [{ type: Input }],
    orderKeys: [{ type: Input }],
    reorder: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OrderingComponent, [{
        type: Component,
        args: [{
                selector: 'ordering',
                template: "<ng-select\n  bdSelect\n  placeholder=\"{{ 'forms.fields.order' | translate }}\"\n  (change)=\"refreshOrdering($event)\"\n  [formControl]=\"form.get('ordering')\"\n  [items]=\"orderKeys\"\n  bindValue=\"key\"\n  bindLabel=\"label\"\n></ng-select>\n\n\n<i class=\"bd-icon bd-icon--big icon-arrow-down\" *ngIf=\"getActiveSort() === 'desc'\" (click)=\"refreshOrdering(true)\"></i>\n<i class=\"bd-icon bd-icon--big icon-arrow-up\" *ngIf=\"getActiveSort() !== 'desc'\" (click)=\"refreshOrdering(true)\"></i>\n\n"
            }]
    }], function () { return [{ type: ɵngcc3.FormBuilder }, { type: ɵngcc1.TranslateService }]; }, { reorder: [{
            type: Output
        }], filterService: [{
            type: Input
        }], orderKeys: [{
            type: Input
        }] }); })();

class OrderComponent {
    constructor() {
        this.active = false;
        this.onOrder = new EventEmitter();
    }
    ngOnInit() {
        this.ordering = this.filter.getOrdering(this.order);
        if (!this.ordering) {
            this.ordering = new Ordering(this.order, (this.dir) ? this.dir : 'asc', this.active);
            this.filter.addOrdering(this.ordering);
        }
    }
    handleOrderClick() {
        this.filter.resetOrderings();
        if (this.ordering.ordering === 'asc') {
            this.ordering.ordering = 'desc';
            this.ordering.active = true;
        }
        else if (this.ordering.ordering === 'desc') {
            this.ordering.active = false;
            this.ordering.ordering = null;
        }
        else {
            this.ordering.ordering = 'asc';
            this.ordering.active = true;
        }
        this.onOrder.emit(this.ordering);
        this.filter.refresh();
    }
}
OrderComponent.ɵfac = function OrderComponent_Factory(t) { return new (t || OrderComponent)(); };
OrderComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OrderComponent, selectors: [["", "order", ""]], inputs: { active: "active", filter: "filter", order: "order", dir: "dir" }, outputs: { onOrder: "onOrder" }, attrs: _c7, ngContentSelectors: _c9, decls: 4, vars: 6, consts: [[1, "order", 3, "click"], [1, "order-action", "asc", 3, "ngClass"], [1, "order-action", "desc", 3, "ngClass"]], template: function OrderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵlistener("click", function OrderComponent_Template_div_click_0_listener() { return ctx.handleOrderClick(); });
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵelement(2, "span", 1)(3, "span", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(2, _c8, ctx.ordering.ordering === "asc" && ctx.ordering.active));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(4, _c8, ctx.ordering.ordering === "desc" && ctx.ordering.active));
    } }, directives: [ɵngcc2.NgClass], styles: ["[_nghost-%COMP%]   .order[_ngcontent-%COMP%]{display:flex;cursor:pointer}[_nghost-%COMP%]   .order[_ngcontent-%COMP%]   .order-action[_ngcontent-%COMP%]{color:#ccc;position:relative;font-size:0;line-height:0;display:inline-block;height:7px;width:7px;border-top:5px solid transparent;border-bottom:5px solid transparent;border-left:7px solid #ccc;margin-left:7px}[_nghost-%COMP%]   .order[_ngcontent-%COMP%]   .order-action.asc[_ngcontent-%COMP%]{transform:rotate(-90deg)}[_nghost-%COMP%]   .order[_ngcontent-%COMP%]   .order-action.asc.active[_ngcontent-%COMP%]{border-left-color:#000}[_nghost-%COMP%]   .order[_ngcontent-%COMP%]   .order-action.desc[_ngcontent-%COMP%]{margin-left:5px;transform:rotate(90deg)}[_nghost-%COMP%]   .order[_ngcontent-%COMP%]   .order-action.desc.active[_ngcontent-%COMP%]{border-left-color:#000}"] });
OrderComponent.ctorParameters = () => [];
OrderComponent.propDecorators = {
    filter: [{ type: Input }],
    order: [{ type: Input }],
    active: [{ type: Input }],
    dir: [{ type: Input }],
    onOrder: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OrderComponent, [{
        type: Component,
        args: [{
                selector: '[order]',
                template: "<div (click)=\"handleOrderClick()\" class=\"order\">\n  <ng-content></ng-content>\n  <span class=\"order-action asc\" [ngClass]=\"{'active': ordering.ordering === 'asc' && ordering.active }\"></span>\n  <span class=\"order-action desc\" [ngClass]=\"{'active': ordering.ordering === 'desc' && ordering.active }\"></span>\n</div>\n",
                styles: [":host .order{display:flex;cursor:pointer}:host .order .order-action{color:#ccc;position:relative;font-size:0;line-height:0;display:inline-block;height:7px;width:7px;border-top:5px solid transparent;border-bottom:5px solid transparent;border-left:7px solid #ccc;margin-left:7px}:host .order .order-action.asc{transform:rotate(-90deg)}:host .order .order-action.asc.active{border-left-color:#000}:host .order .order-action.desc{margin-left:5px;transform:rotate(90deg)}:host .order .order-action.desc.active{border-left-color:#000}"]
            }]
    }], function () { return []; }, { active: [{
            type: Input
        }], onOrder: [{
            type: Output
        }], filter: [{
            type: Input
        }], order: [{
            type: Input
        }], dir: [{
            type: Input
        }] }); })();

class BdFilterModule {
    static forRoot() {
        return {
            ngModule: BdFilterModule,
            providers: []
        };
    }
}
BdFilterModule.ɵfac = function BdFilterModule_Factory(t) { return new (t || BdFilterModule)(); };
BdFilterModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: BdFilterModule });
BdFilterModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule,
            ReactiveFormsModule,
            NgSelectModule,
            FormsModule,
            TranslateModule,
            DatepickerModule,
            PaginationModule,
            FormUtilitiesModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BdFilterModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    ReactiveFormsModule,
                    NgSelectModule,
                    FormsModule,
                    TranslateModule,
                    DatepickerModule,
                    PaginationModule,
                    FormUtilitiesModule
                ],
                declarations: [
                    ResultsPerPageComponent,
                    PaginationFilterComponent,
                    OrderingComponent,
                    FilterComponent,
                    ListLoadingComponent,
                    ListContainerComponent,
                    InfinityListComponent,
                    OrderComponent
                ],
                exports: [
                    ResultsPerPageComponent,
                    PaginationFilterComponent,
                    OrderingComponent,
                    FilterComponent,
                    ListLoadingComponent,
                    ListContainerComponent,
                    InfinityListComponent,
                    OrderComponent
                ],
                schemas: [CUSTOM_ELEMENTS_SCHEMA]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BdFilterModule, { declarations: function () { return [ResultsPerPageComponent, PaginationFilterComponent, OrderingComponent, FilterComponent, ListLoadingComponent, ListContainerComponent, InfinityListComponent, OrderComponent]; }, imports: function () { return [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgSelectModule,
        FormsModule,
        TranslateModule,
        DatepickerModule,
        PaginationModule,
        FormUtilitiesModule]; }, exports: function () { return [ResultsPerPageComponent, PaginationFilterComponent, OrderingComponent, FilterComponent, ListLoadingComponent, ListContainerComponent, InfinityListComponent, OrderComponent]; } }); })();

// Components

/**
 * Generated bundle index. Do not edit.
 */

export { AndFilter, BdFilterModule, CollectionCountFilter, DateTimeRangeFilter, DateTimeRangeFixedIntervalFilter, EqualFilter, Filter, FilterComponent, InFilter, InfinityListComponent, InstanceofFilter, IsNotNullFilter, IsNullFilter, ListContainerComponent, ListLoadingComponent, Ordering, ParamFilter, TextFilter, ResultsPerPageComponent as ɵa, PaginationFilterComponent as ɵb, OrderingComponent as ɵc, OrderComponent as ɵd };

